class SlaaskApp extends EventHandler {

  /*X*/
  // => TODO refacto

  constructor() {
    super();
    this._version = `GULP-VERSION`;
    this._chat_file = `GULP-CHATFILE`;

    let settings = Dom.parent._xenoSettings || Dom.parent._slaaskSettings || Dom.parent._sarbacaneSettings || Dom.parent._polariaSettings;

    this._websocket_url = 'askws.polaria.ai';
    this._encrypted_websocket = true;

    if (this._chat_file == 'debug') {
      let bubbleWindow = window;
      while (bubbleWindow.document.location.href == 'about:blank' && bubbleWindow != window.top) {
        bubbleWindow = bubbleWindow.parent;
      }
      const href = bubbleWindow.document.location.href;
      if (/(polaria\.dev)|(:\/\/localhost)|(:\/\/staging\.polaria\.ai)|(\.internal\.polaria\.app)/.test(href))
        this._post_url = href.match(/(\w+:\/\/.*?)(\/|$)/)[1];
      else if (href == 'file:///android_asset/index.html')
        this._post_url = 'https://xeno.eu.ngrok.io';
      else
        this._post_url = 'http://localhost:3000';
      this._cdn_url       = this._post_url;
      this._vault_url     = this._post_url;
    }
    else {
      if (this._guessBrand() == "xeno") {
        this._post_url   = 'https://xeno.app';
        this._cdn_url    = 'https://cdn.xeno.app';
        this._vault_url  = 'https://vault.xeno.app';
      } else if (this._guessBrand() == "sarbacane") {
        this._post_url   = 'https://chat.sarbacane.com';
        this._cdn_url    = 'https://chat.sarbacane.com';
        this._vault_url  = 'https://chat.sarbacane.com';
      } else if (this._guessBrand() == "polaria" || this._guessBrand() == "Polaria Tech") {
        this._post_url   = 'https://app.polaria.ai';
        this._cdn_url    = 'https://cdn.polaria.ai';
        this._vault_url  = 'https://vault.polaria.ai';
      } else {
        this._post_url   = 'https://slaask.com';
        this._cdn_url    = 'https://cdn.slaask.com';
        this._vault_url  = 'https://vault.slaask.com';
      }

      if (settings && settings.options) {
        if (settings.options.apiUrl) {
          this._post_url = settings.options.apiUrl;
        }
        if (settings.options.cdnUrl) {
          this._cdn_url = settings.options.cdnUrl;
        }
        if (settings.options.vaultUrl) {
          this._vault_url = settings.options.vaultUrl;
        }
        if (settings.options.websocketUrl) {
          this._websocket_url = settings.options.websocketUrl;
        }
      }
    }

    Diagnosis.init(this._cdn_url);

    Utils.bufferCookies(true);

    if (Utils.sessionStorage('opened') == null)
      Utils.sessionStorage('opened', false);

    Ajax.init(this._post_url, () => {
      if (this._jwt) {
        return {
          'key': this._api_key,
          'jwt': this._jwt
        };
      } else {
        return {
          'key': this._api_key,
          'token': this._guest_token,
          'guest_hash': this._guest_hash
        }
      }
    });

    this._askTechParser = new AskTechParser();
    this._askTechParser.config(Object.assign({
      cdnUrl: this._cdn_url
    }, this._askTechParserPageContext()));

    Utils.forEach(AbstractModule.list, (module) => {
      module.attachSlaask(this);
    });

    /* PRIVATE */

    this.__user_infos               = null; // Private, use the _user_infos getter and setter
    this._agents_members_count      = 0;
    this._ai_warning_modal_enabled  = false;
    this._ai_warning_text           = '';
    this._ai_warning_title           = '';
    this._ai_warning_page_content   = '';
    this._already_registered        = false;
    this._analytics_keys            = [];
    this._pii_tokens                = [];
    this._api_key                   = '';
    this._api_ws_token              = '';
    this._ask_tech_shared_storage   = false;
    this._bot_description           = '';
    this._bot_email_text            = '';
    this._bot_img                   = '';
    this._bot_name                  = '';
    this._force_loading             = false;
    this._can_re_identify           = false;
    this._chat_color                = '#f6f7fb'
    this._chat_text_color           = '#444444'
    this._conversation_closed       = false;
    this._cookies_on_subdomains     = true;
    this._cookies_fallback          = {};
    this._debug                     = false;
    this._display_bubble            = true;
    this._email_asked               = false;
    this._errored                   = false;
    this._faqs_count                = 0;
    this._fb_infos                  = {};
    this._force_cache_last          = true;
    this._force_offline             = false;
    this._forced_bot_tree           = null;
    this._forced_user_group_id      = 0;
    this._guest_hash                = null;
    this._jwt                       = null;
    this._guest_id                  = '';
    this._guest_lat                 = 0;
    this._guest_lng                 = 0;
    this._guest_token               = false;
    this._hide_on_mobile            = false;
    this._hide_slaask_button_option = false;
    this._disabled_on_mobile        = false;
    this._in_iframe                 = this.isInIframe();
    this._initialized               = false;
    this._is_ie                     = (navigator.userAgent.indexOf("MSIE") != -1) || (navigator.appVersion.indexOf('Trident/') > 0);
    this._is_iphone                 = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    this._is_touch                  = null;
    this._is_touch_last_update      = 0;
    this._language                  = (navigator.languages && navigator.languages[0]) || navigator.language || navigator.browserLanguage;
    this._last_message              = null;
    this._last_messages_hash        = [];
    this._last_sender               = null;
    this._large_preview_enabled     = settings && settings.options ? settings.options.largePreviewEnabled : false;
    this._loaded                    = false;
    this._make_room_for_topbar      = true;
    this._members_count             = 0;
    this._mobile_threshold          = 470;
    this._nativeSdk                 = false;
    this._open_in_popup             = false;
    this._presence_channel          = null;
    this._previous_guest_token      = false;
    this._pulsing_enabled           = false;
    this._websocketClient           = null;
    this._websocketClientEnabled    = false;
    this._websocketConnecting       = false;
    this._websocket_version         = 'pusher';
    this._ready                     = false;
    this._reconnecting              = false;
    this._require_js                = "function" == typeof define && define.amd;
    this._save_open_state           = true;
    this._shared_storage_activated  = settings ? !!(settings.multiDomain && !settings.noCookie) : false;
    this._source                    = 'web';
    this._state                     = null;
    this._stored_identify           = null;
    this._stored_information        = { };
    this._stored_options            = { };
    this._typed_text                = Utils.localStorage('typed-text') || '';
    this._unread_messages           = 0;
    this._user_group_alert_message  = '';
    this._user_group_id             = 0;
    this._user_group_kind           = 'one';
    this._user_group_name           = '';
    this._video_chat_domain         = 'asktech.daily.co';
    this._view_branch               = null;
    this._view_depth                = 0;
    this._destroyed                 = false;
    this._xeno                      = null;

    this._setTouchDevice(Utils.localStorage('touch') || false);

    Diagnosis.step('script-initialized');

    if (settings) {
      if (this._shared_storage_activated) {
        this._ask_tech_shared_storage = new AskSharedStorage(`${this._vault_url}/api/${settings.key}/session.html`)
      }

      if (settings.autoInit !== false) this.identifyContact();
      if (settings.onInit) settings.onInit(this);
    }
  }

  get _user_infos() {
    return this.__user_infos;
  }

  set _user_infos(value) {
    this.__user_infos = value;
    this._askTechParser.config({
      userInfos: this.__user_infos
    });
  }


  /******************/
  /***** PUBLIC *****/
  /******************/

  /* INIT */

  init(key, options, callback) {
    if (this._initialized) {
      return { success: false, error: 'Already initialized' };
    }

    if (/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
      return { success: false, error: 'Slaask is disabled for search crawlers' };
    }

    this._api_key = key;
    this._initWithOptions(options);

    Utils.log('Initialization');
    Diagnosis.step('init-function');

    this._initialized = true;
    if (typeof callback !== 'undefined')
      callback(this._guest_token);

    this._initAsync();
  }

  get initialized() {
    return this._initialized;
  }


  /* IDENTIFY VISITOR */

  /**
   * This function allows to specify the identity of the visitor.
   * The "id" is a unique ID that identifies the visitor.
   * "id" and "name" are mandatory.
   *
   * For SPA: If the visitor has already been identified, calling
   * this function will completely reload the chatbox. This is
   * useful when the user signed in another account.
   *
   * Supports JWT token format via the "jwt" field in the info object.
   *
   * @param  {object} info Object containing info about the visitor. "id" and "name" are mandatory, or "jwt" for JWT token.
   */
  auth() { return this.identify.apply(this, arguments); }
  identify(info) {
    // Backup arguments in case we need to force reload the script
    this._stored_identify = Utils.argumentsToArray(arguments);

    // Check if info is an object with a "jwt" field
    if (typeof info == "object" && info && typeof info['jwt'] != "undefined" && info['jwt']) {
      // JWT mode: store the JWT token and let the server handle everything
      this._jwt = info['jwt'];
      this._guest_hash = null;
      // Clear user_infos as the server will extract them from the JWT
      this._user_infos = null;
      this._guest_token = null;
      Diagnosis.step('identify-function-jwt');
      return;
    }

    // Normal mode: traditional object format
    info = Utils.clone(info);

    if (typeof info == "object" || !info) {
      let temp_id     = info ? info['id'] || info['_id'] || info['user_id'] || info['email'] : null;
      let temp_name   = info ? info['name'] : null;

      if (temp_id == 'asktech_snippet_not_edited') {
        throw "Please follow all the steps from the deploy page of " + Utils.capitalize(this._guessBrand()) + ".\nThis code snippet requires code editing and understanding.";
      }

      // For SPA. If the guest was already identified, we reload the script. Only if the new ID is different
      if (this._can_re_identify) {
        let isLoggedIn = info && temp_id;

        let isSameContact = isLoggedIn
                            ? this._guest_token == temp_id
                            : this._guest_token == this._getOrGenerateCookieToken();

        if (!isSameContact) this._reIdentify.apply(this, arguments);
      }

      // Otherwise, we identify the guest with those info
      else if (info) {
        delete info['id'];
        delete info['name'];

        if (!Utils.exists(temp_id) || !Utils.exists(temp_name)) {
          Utils.publicWarn(`The chatbox needs at least a "name" and an "id" to identify the visitor. The visitor won't be identified.`);
          Diagnosis.warn('identify-mandatory-attributes');
        }
        else {
          if (typeof info['user_hash'] != "undefined") {
            this._guest_hash = info['user_hash'];
            this._jwt = null;
          }

          this._guest_token = temp_id
          this._user_infos  = {
            'id': temp_id,
            'display_name': temp_name,
            'more': info
          };

          Diagnosis.step('identify-function');
        }
      }

    }

    // Retro compatibility
    else if (info) {
      this._user_infos = {
        'display_name': arguments[0],
        'more': arguments[1]
      }
    }
  }

  /**
   * Handles initialization of the chatbox using _xenoSettings or _slaaskSettings
   *
   * window._xenoSettings = {
   *   identify: function() {
   *     return {
   *       id: 1337,
   *       name: "John Doe"
   *     }
   *   },
   *   key: "xpk-12345",
   *   options: { debug: true },
   *   autoInit: true
   * }
   */
  identifyUser() { return this.identifyContact.apply(this, arguments); }
  async identifyContact() {
    let settings = this._settings;
    if (settings) {

      let underscoresWasDefined = Dom.parent.hasOwnProperty('____');
      let underscoresBackup = Dom.parent.____;
      Dom.parent.____ = "asktech_snippet_not_edited";

      try {
        if (this._shared_storage_activated) {
          // Read
          this._stored_information = await this._sharedStorage(settings.key) || { };

          // Ensure the presence of anonymous ID
          if (!this._stored_information.anonymousId)
            this._stored_information.anonymousId = this._getOrGenerateCookieToken(settings.key);

          if (settings.anonymousToken)
            this._stored_information.anonymousId = settings.anonymousToken;

          let identity = null;

          // Try to find something that will identify the Contact
          if (settings.identify) {
            identity = settings.identify();
          }
          else if (this._stored_information.identityId) {
            identity = {
              id: this._stored_information.identityId,
              name: this._stored_information.identityName,
              user_hash: this._stored_information.identityHash
            };
          }

          // Known user
          if (identity) {
            this._stored_information.identityHash = identity.user_hash;
            this._stored_information.identityId   = identity.id;
            this._stored_information.identityName = identity.name;
          }
          // Anonymous user
          else {
            this._guest_token = this._stored_information.anonymousId;
          }

          this.identify(identity);

          // Write
          this._sharedStorage(settings.key, this._stored_information);
        }

        else this.identify(settings.identify ? settings.identify() : null);
      }
      catch (e) {
        if (!underscoresWasDefined) delete Dom.parent.____;
        else Dom.parent.____ = underscoresBackup;
        throw e;
      }

      Dom.parent.____ = underscoresBackup;

      if (settings.key && !this._initialized) {
        this.init(settings.key, settings.options);
      }
    }
  }

  /**
   * Updates and sends to the server the info given in the identify function.
   * The Visitor ID can't be changed here: The visitor is still the same, but we have more info about them.
   * Can be used to update their current_page.
   *
   * @param  {object}   infos
   * @param  {Function} callback Takes response from the server as parameter
   * @return {Promise}           Returns response from the server
   */
  async updateUserInfos() { return this.updateContact.apply(this, arguments); }
  async updateVisitorInfos() { return this.updateContact.apply(this, arguments); }
  async updateVisitorInfo() { return this.updateContact.apply(this, arguments); }
  async updateUser() { return this.updateContact.apply(this, arguments); }
  async updateContact(infos = null, options = null, callback = null) {
    // (infos, callback) function signature
    if (!callback && typeof options == 'function') {
      callback = options
      options = null
    }

    if (this._user_infos == null) {
      this._user_infos = {}
    }

    let default_infos = {
      'key': this._api_key,
      'token': this._guest_token,
      'user_infos': this._user_infos,
      'current_page': Dom.parent.location.href,
      'current_page_title': Dom.parent.document.title,
      'triggers_check': options && options.triggersCheck
    }

    if (infos) {
      if (infos['name']) this._user_infos['display_name'] = infos.name;
      if (infos['current_page']) {
        default_infos['current_page'] = infos['current_page'];
        delete infos['current_page'];
      }

      // Delete id, Override current_page and name
      delete infos['id'];
      delete infos['name'];

      // Merge infos with user_infos.more. Values from infos will take priority
      Utils.feedIfEmpty(infos, this._user_infos['more']);
      this._user_infos['more'] = infos;
      default_infos['user_infos'] = this._user_infos;
    }

    let ajaxData = await Ajax.call('/api/update_visitor', default_infos);

    if (ajaxData.triggers) {
      Triggers.processTriggersList(ajaxData.triggers)
    }

    if (typeof callback == "function") callback(ajaxData);
    return ajaxData;
  }

  /**
   * @param  {string} infoName Name of the info to get
   * @return {any}             Returns the desired info, or null if not defined
   */
  getUserInfo() { return this.getContactInfo.apply(this, arguments); }
  getContactInfo(infoName) {
    if(infoName == 'name') {
      if(this._user_infos == null) {
        return null
      } else {
        if(this._user_infos['display_name'].split('-#')[0] == 'Visitor') {
          return null
        } else {
          return this._user_infos['display_name'].split('-#')[0]
        }
      }
    } else {
      if (this._user_infos == null || this._user_infos['more'] == null) {
        return null
      } else {
        return this._user_infos['more'][infoName]
      }
    }
  }
  getContactCountry(country) {
    return this._user_country;
  }

  async logout(apiKey) {
    let settings = this._settings;
    apiKey = apiKey || this._api_key || settings.key;
    this._ask_tech_shared_storage = new AskSharedStorage(`${this._vault_url}/api/${apiKey}/session.html`);
    let storedInformation = await this._sharedStorage(apiKey);
    delete storedInformation['identityId'];
    delete storedInformation['identityHash'];
    delete storedInformation['identityName'];
    await this._sharedStorage(apiKey, storedInformation);
    this.destroy();
  }


  /* MESSAGES */

  get MessageSampleMap() { return this.MessageSample; }
  get MessageSample() {
    return MessageSample;
  }

  get Message() {
    return Message;
  }

  /**
   * Usage:
   * message(Message)
   * message("Lorem ipsum", "John Doe", null, "http://example.com/john_doe.jpg")
   *
   * Example:
   * var message = new _brand.Message(_brand.MessageSample.support, "Lorem ipsum");
   * _brand.message(message);
   *
   * @param  {Message} message
   * @param  {number} conversation_id
   */
  message() { return this.addMessage.apply(this, arguments); }
  sendMessage() { return this.addMessage.apply(this, arguments); }
  addMessage(message, conversation_id) {
    if (!(message instanceof Message)) {
      let msgData = {
        text       : arguments[0],
        name       : arguments[1],
        action_link: arguments[2],
        image      : arguments[3],
        trigger_id : arguments[4]
      };
      Utils.feedIfEmpty(msgData, MS.support);
      message = new Message(msgData);

      conversation_id = Conversations.current.id;
    }

    let conversation;
    if (Utils.defined(conversation_id)) conversation = Conversations.get(conversation_id);
    if (!conversation) conversation = Conversations.current;

    conversation.addMessage(message);
  }

  /**
   * Sends a message to the server as if the guest sent one from the input
   *
   * @param  {string}   text     Text message to send
   * @param  {Function} callback Callback taking "sent" as first argument
   * @return {Promise}           Promise resolving with a "sent" boolean telling wether the message
   *                             could be sent in a conversation or not
   */
  sendMessageAsGuest() { return this.sendMessageAsContact.apply(this, arguments); }
  async sendMessageAsContact(text, callback) {
    let conversations = [Conversations.current].concat(Conversations.toArray()).concat(Conversations.temp_conversation);
    let sent = false;
    for (let i = 0; i < conversations.length; i++) {
      if (conversations[i] && conversations[i].shouldDisplayInput()) {
        await Dom.get('widget').buildIfNeeded();
        Views.jumpToViewByName('conversation', conversations[i].id);
        await Utils.delay(Conversations.displayDelayOnOpen);
        Dom.findById('widget', 'slaask-input').value = text;
        Conversations.submitOnlineForm();
        sent = true;
        break;
      }
    }
    return sent;
  }

  get conversations() {
    return Conversations.getMessagesLists();
  }

  getConversations() {
    return Conversations.toArray();
  }

  removeAllBubbles() {
    Notifier.removeAllBubbles()
  }

  /* SURVEYS */

  surveys() {
    Surveys.processNextSurvey()
  }

  survey(survey_id) {
    if (typeof survey_id !== 'undefined') {
      Surveys._current_survey = survey_id - 1;
      Surveys.processNextSurvey()
    }
  }


  /* MEETINGS */

  async setMeeting(meeting_type, day, hour, timezone, callback) {
    return Meetings.set.apply(Meetings, arguments);
  }

  async cancelMeeting(token, callback, force) {
    return Meetings.cancel.apply(Meetings, arguments);
  }

  async rescheduleMeeting(token, day, hour, timezone, callback) {
    return Meetings.reschedule.apply(Meetings, arguments);
  }

  async getMeetingTypes(meeting_type_id, callback) {
    return Meetings.getTypes.apply(Meetings, arguments);
  }

  /* NOTIFICATIONS */

  get unreadMessagesCount() {
    return Notifier.unread_messages;
  }


  /* CHANGELOGS */

  async setNewsView(newsId, callback) {
    this._deprecationWarning();
  }

  async setNewsReaction(newsId, reaction, callback) {
    this._deprecationWarning();
  }

  async getNewsReaction(newsId, callback) {
    this._deprecationWarning();
  }

  async getNews(newsId, callback) {
    this._deprecationWarning();
  }

  get unreadNewsIds() {
    this._deprecationWarning();
    return [];
  }


  /* HOMEPAGE */

  createHomepageCustomBlocks(blocks) {
    return Homepage.createCustomBlocks.apply(Homepage, arguments)
  }

  buildHomepageCard(layouts, data = { settings: null, settingsFormat: null }, types = null) {
    const previews = [];
    const tmpElement = document.createElement('div')
    HtmlBuilder.setBuildType("EDITOR");

    layouts.forEach((layout) => {
      const layoutElement = HtmlBuilder.buildHtml(layout, data.settings, data.settingsFormat, types)
      previews.push(layoutElement);
      tmpElement.appendChild(layoutElement);
    })

    if (data && types) {
      const postBuildData = {
        settings: data.settings,
        domElement: tmpElement
      };

      HtmlSettings.loadPostBuildSettings(types.blockLabel, postBuildData)
    }

    HtmlBuilder.reset();

    return(previews);
  }

  overrideHomepageViewElement(cards) {
    const homepageView = Views.getByName('homepage')
    let updatedHomepageHtml = ''

    HtmlBuilder.setBuildType("HOMEPAGE");

    const cardsBuilt = homepageView.buildCards(cards)

    cardsBuilt.forEach(function(cardBuilt) {
      updatedHomepageHtml += cardBuilt
    })

    if (updatedHomepageHtml === '') {
      homepageView.setContent(homepageView._oldHtmlBase())
      homepageView.useOldCards()
    } else {
      homepageView.setContent(updatedHomepageHtml)
      homepageView.useNewCards()
    }
  }

  isOldHomepage () {
    return !this._new_homescreen
  }

  /* EVENTS */

  on(event, callback) {
    super.on(event, (e) => {
      callback({ event: this._guessBrand() + "." + event, detail: e });
    });
  }

  track(event) {
    Ajax.call('/api/track', { 'key': this._api_key, 'guest_token': this._guest_token, 'event': event });
  }

  /* DOM */

  show() {
    return Dom.showWidget.apply(Dom, arguments);
  }

  hide() {
    return Dom.hideWidget.apply(Dom, arguments);
  }

  setWidgetSize(size) {
    return Dom.setWidgetSize.apply(Dom, arguments);
  }

  /**
   * goBackToPreviousView
   * @return {boolean} Wether the command was successful or not
   */
  goBackToPreviousView() {
    return Views.jumpToPrevious(Utils.NON_STRICT);
  }

  isOpened() { return this.isOpen.apply(this, arguments); }
  isOpen() {
    return Views.widget_open;
  }

  isInIframe() {
    return Dom.isInIframe.apply(Dom, arguments);
  }

  parentWindow() {
    return Dom.parent;
  }

  getScreenSize() {
    return this.getScreenWidth();
  }

  getScreenWidth() {
    return Dom.parent.innerWidth || Dom.parent.document.documentElement.clientWidth || Dom.parent.document.getElementsByTagName('body')[0].clientWidth;
  }

  getScreenHeight() {
    return Dom.parent.innerHeight || Dom.parent.document.documentElement.clientHeight || Dom.parent.document.getElementsByTagName('body')[0].clientHeight;
  }

  createScriptTag(src) {
    if (this._require_js) {
      var t = {};
      require([src], function(lib) { t.onload(lib); });
      return t;
    }
    else {
      var scriptTag = document.createElement('script');
      requestAnimationFrame(() => {
        scriptTag.src = src;
        document.getElementsByTagName('head')[0].appendChild(scriptTag);
      });
      return scriptTag;
    }
  }


  /* PARSING */

  parseMessageHtml(text, noEmbedly, noVariables) {
    this._deprecationWarning();
    text = this._parseMessageHtml.apply(this, arguments);
    return Emoji.emojify(text);
  }

  parseUserMessageHtml(text, noEmbedly, noVariables) {
    this._deprecationWarning();
    if (text == null) { return '' }
    text   = this._askTechParser.parseMessageMailto(text);
    if (noVariables == null) {
      text = this._askTechParser.parseMessageVariables(text);
    }
    text   = this._askTechParser.LightMarkdown.toHtml(text, noEmbedly);
    return this._askTechParser.Emoji.emojify(text);
  }

  emojiParser(text, url, options) {
    return Emoji.parser(text, url, options);
  }


  /* TRIGGERS */

  resetTriggers() {
    Dom.addClass('tooltip', 'slaask-hidden');
  }

  replaceAlert() {
    Triggers.replaceAlert();
  }

  clearTriggers() {
    Triggers.clearTriggers()
  }


  /* BOT TREE */

  /**
   * @param {any} botTreeId May be an id, uuid or name
   */
  setBotTree(botTreeId) {
    this._forced_bot_tree = botTreeId;
    this._bot_tree_enabled = true;
  }

  contactCommittedToNewConversation() {
    if (!Conversations.didUserCommitToNewConversation()) {
      Conversations.userCommittedToNewConversation();
    }
  }

  /**
   * Opens the chatbox on a new conversation
   * @param {string|number} options.botTree Bot tree ID, UUID, or name
   * @param {boolean} options.contactCommitted Did the contact commit to create
   *   a new conversation by clinking on a button or something similar
   */
  startConversation(options = {}) {
    if (Conversations.canOpenNew()) {
      const conversation = Conversations.get(null);
      if (options.botTree) {
        conversation.forced_bot_tree = options.botTree;
      }
      if (options.contactCommitted && !Conversations.didUserCommitToNewConversation()) {
        Conversations.userCommittedToNewConversation();
      }
      Conversations.open(conversation);
      Dom.show();
    }
    else {
      Utils.publicWarn("A conversation is already active, can't start a new one");
      Conversations.open(Conversations.last_private);
    }
  }


  /* MISC */

  isLive() {
    return this._available && !this._force_offline;
  }

  getApiKey() { return this.getPublicKey.apply(this, arguments); }
  getPublicKey() {
    return this._api_key;
  }

  getGuestToken() {
    return this._guest_token;
  }

  getCdnUrl() {
    return this._cdn_url;
  }

  toggleDebug(enable = !this._debug) {
    this._debug = enable;
    Utils.enableLogs(this._debug);
    if (enable) {
      this._mods = AbstractModule.list;
    }
    this._Utils = Utils;
  }

  handleImageLoad(element) {
    let liContainer = Utils.closest(element, "li");
    if (liContainer) {
      let message = Message.get(Utils.dataSet(liContainer, 'id'));
      Conversations.keepScrollOnBottom(message.conversation);
    }
    Triggers.replaceAlert();
  }

  /* DEPRECATED */

  // Deprecated in favor to _brand.message() (2019-02-07)
  addToCurrentConversation() { return this.addToConversation.apply(this, arguments); }
  addToConversation(text, conversationId) {
    this._deprecationWarning();
    let conversation = Conversation.get(typeof conversationId == "undefined" ? Conversations.current.id : conversationId);
    let message = new Message(MS.support);
    message.text = text;
    conversation.addMessage(message);
  }

  updateLastMessageWithConversationId(conversation_id) { this._deprecationWarning(); }
  sendMessageToSlack() { this._deprecationWarning(); }

  _deprecationWarning() {
    Utils.publicWarn('This function is deprecated. For further explanations, come chat with us at https://get.slaask.com/#chat-open ' + EmojiMap.slightly_smiling_face);
  }

  /*******************/
  /***** PRIVATE *****/
  /*******************/

  /* INIT */

  _initWithOptions(options = {}) {
    this.toggleDebug(false);

    this._stored_options = options || {};

    if (Utils.exists(options.debug))
      this.toggleDebug(options.debug);

    if (Utils.exists(options.user_hash))
      this._guest_hash = options.user_hash;

    if (Utils.exists(options.display_bubble))
      this._display_bubble = options.display_bubble;
    else
      this._display_bubble = true;

    if (Utils.exists(options.custom_url)) {
      this._post_url  = options.custom_url;
      this._cdn_url   = options.custom_url;
    }
    if (Utils.exists(options.cdn_url))
      this._cdn_url = options.cdn_url;

    if (Utils.exists(options.user_group_id))
      this._forced_user_group_id = options.user_group_id;
    if (Utils.exists(options.team_id))
      this._forced_user_group_id = options.team_id;

    if (Utils.exists(options.force_cache_last))
      this._force_cache_last = options.force_cache_last;

    if (Utils.exists(options.cookies_on_subdomains))
      Utils.cookiesOnSubDomain = options.cookies_on_subdomains;

    if (Utils.exists(options.source))
      this._source = options.source;

    if (Utils.exists(options.fb_infos))
      this._fb_infos = options.fb_infos;

    if (Utils.exists(options.language))
      this._language = options.language;

    if (Utils.exists(options.mobile_threshold))
      this._mobile_threshold = options.mobile_threshold;

    if (Utils.exists(options.force_offline))
      this._force_offline = options.force_offline;

    if (Utils.exists(options.pulse))
      this._pulsing_enabled = options.pulse;

    if (Utils.exists(options.custom_css))
      Dom.customCss = options.custom_css;

    if (Utils.exists(options.native_sdk))
      this._nativeSdk = options.native_sdk;

    if (Utils.exists(options.nativeSdk))
      this._nativeSdk = options.nativeSdk;

    if (Utils.exists(options.user_token))
      options.visitor_token = options.user_token;

    if (Utils.exists(options.visitor_token))
      this._updateGuestToken(options.visitor_token);
    else
      this._loadGuestToken();

    if (Utils.exists(options.bot_tree))
      this._forced_bot_tree = options.bot_tree;

    if (Utils.exists(options.homepage_disabled))
      this._homepage_disabled = options.homepage_disabled;

    if (Utils.exists(options.homepage_cards))
      this._custom_cards = options.homepage_cards;

    if (Utils.exists(options.homepage_global_scope))
      this._homepage_global_scope = options.homepage_global_scope

    if (Utils.exists(options.open_in_popup))
      this._open_in_popup = options.open_in_popup && !Dom.isInPopup();

    if (Utils.exists(options.offline_mode))
      this._offline_mode = options.offline_mode;

    if (Utils.exists(options.color))
      this._window_color = options.color;

    if (Utils.exists(options.hide_button))
      this._hide_slaask_button_option = options.hide_button;

    if (Utils.exists(options.force_loading))
      this._force_loading = options.force_loading;

    if (Utils.exists(options.make_room_for_topbar))
      this._make_room_for_topbar = options.make_room_for_topbar;

    if (Utils.exists(options.favicon_counter))
      this._favicon_counter = options.favicon_counter;

    if (Utils.exists(options.save_open_state))
      this._save_open_state = options.save_open_state;
  }

  _updateGuestToken(newToken) {
    let previousToken = this._getOrGenerateCookieToken();
    if (previousToken != newToken)
      this._previous_guest_token = previousToken;
    this._guest_token = newToken;
  }

  _loadGuestToken() {
    if(this._guest_token == false) {
      this._guest_token = this._getOrGenerateCookieToken();
    }
  }

  _reIdentify() {
    this._reloadApp(arguments);
  }

  _reloadApp(identifyArguments) {
    this.destroy();
    delete this._stored_options.visitor_token;
    delete this._stored_options.user_token;
    this._stored_options.force_cache_last = false;
    let jsBrand = "_" + this._guessBrand();
    window[jsBrand] = new SlaaskApp();
    if (!window[jsBrand].initialized) {
      window[jsBrand].identify.apply(window[jsBrand], identifyArguments ? identifyArguments : this._stored_identify);
      window[jsBrand].init(this._api_key, this._stored_options);
    }
    return window[jsBrand];
  }

  async _initAsync() {
    await Diagnosis.startIn(3000);

    let initSucceeded = await this._fetchServerConfig();

    if (initSucceeded) {
      await this._untilBodyIsAvailable();
      await Dom.appendToDom();
      Diagnosis.step('append-to-dom');

      this._initScriptInteractions();
      Dom.get('widget').when('ready').then(() => {
        this._initFileSharing();
        this._initFormSubmit();
        this._initTimeAgo();
      });

      setInterval(() => {
        this._updateVideoCallButton();
      }, 1000);
      
      Views.forEach(view => {
        view.on('active', () => {
          this._updateVideoCallButton();
        });
      });

      this._triggerInternalEvent('ready', { online: this.isLive() });
      this._eventHappened('ready');

      Diagnosis.success();
    }

  }

  /**
   * @returns {Promise<boolean>} Whether the initialization succeeded or not
   */
  async _fetchServerConfig() {
    const requestData = {
      'user_infos': this._user_infos,
      'current_page': Dom.parent.location.href,
      'current_page_title': Dom.parent.document.title,
      'language': this._language,
      'platform': Platform
        ? Platform.os.family + ' (' + Platform.os.version + ')'
        : 'Unknown',
      'browser': Platform
        ? Platform.name + ' (' + Platform.version + ')'
        : 'Unknown',
      'timezone_offset': new Date().getTimezoneOffset(),
      'in_iframe': Dom.isInIframe(),
      'source': this._source,
      'options': {} // Optional data
    }

    if (!this._already_registered) {
      requestData['referrer'] = Dom.parent.document.referrer
    }

    if (this._stored_identify) {
      if (this._shared_storage_activated) {
        var anonymousToken = this._stored_information.anonymousId;
      } else {
        var anonymousToken = this._getOrGenerateCookieToken();
      }
      if (anonymousToken != this._guest_token) {
        requestData.options['previous_guest_token'] = anonymousToken;
      }
    }

    if (this._forced_user_group_id) {
      requestData.options['forced_user_group_id'] = this._forced_user_group_id
    }

    const marketoCookie = Utils.getCookie("_mkto_trk");
    if (marketoCookie) requestData.options.marketo_munchkin = marketoCookie;

    const responseData = await Ajax.call('/api/init', requestData).catch(response => {
      Diagnosis.error(response);
      throw response;
    });

    if (!responseData.success || responseData.error) return false;

    // Disabled on page
    if (responseData.code == 'page_disabled') {
      Diagnosis.error(responseData);
      Utils.publicLog(responseData.message);
      return false;
    }

    // Out of date script
    if (this._isScriptOutOfDate(responseData.config.widget.version)) {
      if (this._in_iframe) {
        Utils.warn("The script is marked as out-of-date, but was loaded in iframe. This is not an expected behavior.")
      }
      else {
        this._reloadScript(responseData.config.widget.version)
        Utils.publicWarn(`Cached version (${this._version}), forcing new version (${responseData.config.widget.version})`)
        return false
      }
    }

    this._triggerInternalEvent('server_config_fetched', { data: responseData.config }, false);

    this._initWidgetFromServerConfig(responseData.config.widget);

    if (!this._isWidgetEnabled()) {
      Diagnosis.warn("disabled-when-offline");
      Diagnosis.success();
      return false;
    }

    this._initTextsFromServerConfig(responseData.config.texts);
    this._initGuestFromServerConfig(responseData.config.guest);

    return true;
  }

  /**
   * @typedef {Record<string, string>} TextsConfig
   * @typedef {Record<string, any>} WidgetConfig
   * @typedef {Record<string, any>} GuestConfig
   * @typedef {{
   *  success: boolean,
   *  config: {
   *    texts: TextsConfig,
   *    widget: WidgetConfig,
   *    guest: GuestConfig
   *  }
   * }} ServerConfigResponse
   */

  /**
   * @param {WidgetConfig} config
   * @returns {boolean}
   */
  _initWidgetFromServerConfig (config) {
    this._ai_warning_modal_enabled        = config.ai_warning_modal_enabled;
    this._ai_warning_text                 = config.ai_warning_text || '';
    this._ai_warning_title                = config.ai_warning_title || '';
    this._ai_warning_page_content         = config.ai_warning_page_content || '';
    this._alert_background_color          = config.alert_background_color;
    this._alert_text_color                = config.alert_text_color;
    this._analytics_keys                  = config.analytics_keys;
    this._pii_tokens                      = config.pii_tokens;
    this._api_ws_token                    = config.api_ws_token;
    this._available                       = this._force_offline ? false : config.available;
    this._bot_description                 = config.bot_description;
    this._bot_email_text                  = config.bot_email_text;
    this._bot_img                         = config.bot_image || config.support_img;
    this._bot_name                        = config.bot_name || config.displayed_name;
    this._bot_tree_enabled                = config.bot_tree_enabled || !!this._forced_bot_tree || false;
    this._brand_name                      = config.brand_name;
    this._button_size                     = config.button_size || 72;
    this._chattranscript_enabled          = config.chattranscript_enabled;
    this._connect_every_guest             = config.connect_every_guest;
    this._custom_cards                    = this._custom_cards || config.custom_cards
    this._diplay_members                  = config.diplay_members;
    this._direction                       = config.direction;
    this._disabled_on_mobile              = config.disabled_on_mobile;
    this._email_asking                    = config.email_asking;
    this._email_asking_time               = config.email_asking_time;
    this._email_asking_time_in_conv       = config.email_asking_time_in_conv;
    this._faqs_count                      = config.faqs_count;
    this._file_sharing_activated          = config.file_sharing_activated && !Utils.isIe9;
    this._disable_iframe_widget_upload    = config.disable_iframe_widget_upload === true;
    this._full_width_button               = config.full_width_button;
    this._guest_chat_color                = this._window_color || config.window_color;
    this._guest_chat_text_color           = config.title_color;
    this._handle_delayed_by_email         = config.handle_delayed_by_email;
    this._hc_enabled                      = config.hc_enabled;
    this._help_center_url                 = config.help_center_url;
    this._hide_emoji_button                 = config.hide_emoji_button;
    this._hide_gif_button                 = config.hide_gif_button;
    this._homepage_texts                  = config.homepage_texts;
    this._homepage_texts_fallback         = config.homepage_texts_fallback;
    this._marketo_integration_enabled     = config.marketo_integration_enabled
    this._meetings_base_url               = config.meetings_base_url;
    this._message_displayed_image         = config.message_displayed_image;
    this._mini_widget                     = this.getScreenWidth() < this._mobile_threshold || this._chat_file == 'native' ? false : config.mini_widget;
    this._new_homescreen                  = config.custom_cards.length !== 0
    this._newsletter_enabled              = config.newsletter_enabled;
    this._offline_email_address           = config.offline_email_address;
    this._offline_mode                    = typeof this._offline_mode !== 'undefined' ? this._offline_mode : config.offline_mode;
    this._old_custom_cards                = config.old_custom_cards;
    this._pattern_image                   = config.pattern_image;
    this._ph_info                         = config.ph_info;
    this._phone_enabled                   = config.phone_enabled;
    this._phone_number                    = config.phone_number;
    this._pulsing_enabled                 = this._pulsing_enabled == false ? config.pulsing_enabled : this._pulsing_enabled;
    this._realtime_token                  = config.realtime_token;
    this._reply_mode                      = config.reply_mode;
    this._screensharing_enabled           = config.screensharing_enabled;
    this._sendscreenshot_enabled          = config.sendscreenshot_enabled && Platform.name != "IE" && !Dom.isInPopup();
    this._show_welcome_message            = config.show_welcome_message ? this.getScreenWidth() >= this._mobile_threshold : false;
    this._sound_active                    = config.sound_active;
    this._start_with_faq                  = config.start_with_faq;
    this._status                          = config.status;
    this._status_enabled                  = config.status_enabled;
    this._status_page_url                 = config.status_page_url;
    this._status_updated                  = config.status_updated;
    this._support_img                     = config.support_img;
    this._support_name                    = config.displayed_name;
    this._team_id                         = config.team_id;
    this._ticketing_system_enabled        = config.ticketing_system_enabled;
    this._ticketing_system_names          = config.ticketing_system_names;
    this._time_before_message             = config.time_before_message;
    this._time_showing_message            = config.time_showing_message;
    this._title_color                     = config.title_color;
    this._users_default_disconnected      = config.users_default_disconnected;
    this._ephemeral_conversations_enabled = config.ephemeral_conversations_enabled;
    this._videochat_enabled               = config.videochat_enabled;
    this._whitelabel_html                 = config.whitelabel_html;
    this._whitelabel_link                 = config.whitelabel_link;
    this._widget_left                     = config.widget_left;
    this._x_offset                        = config.x_offset;
    this._y_offset                        = config.y_offset;
    this._websocket_version               = config.websocket_version;
    this._widget_users                    = config.widget_users;
    this._window_color                    = this._window_color || config.window_color;
    this._xeno                            = config.multiple_conversations;

    this._askTechParser.config(Object.assign({
      users: this._widget_users,
      piiTokens: this._pii_tokens
    }, this._askTechParserPageContext()));

    this._triggerInternalEvent('widget_init', { data: config }, false);
    this._eventHappened('widget_init');
    Diagnosis.step('widget-initialized');

    return true;
  }

  _initGuestFromServerConfig(config) {
    this._already_registered              = config.already_registered;
    this._api_ws_token                    = config.token;
    this._conversation_closed             = config.closed;
    this._email_asked                     = config.email_asked;
    this._guest_country                   = config.country;
    this._guest_id                        = config.id;
    this._guest_lat                       = config.latitude;
    this._guest_lng                       = config.longitude;
    this._guest_name                      = config.name;
    this._manual_messages_activated       = config.manual_messages_activated;
    this._user_group_alert_message        = config.user_group_alert_message;
    this._user_group_id                   = config.user_group_id;
    this._user_group_kind                 = config.user_group_kind;
    this._user_group_name                 = config.user_group_name;

    if (!this._user_infos) this._user_infos = {};
    Utils.feedIfEmpty(this._user_infos, config.user_infos);

    if (!this._user_infos.more) this._user_infos.more = {}
    const remoteMore = Utils.deepGet(config, ['user_infos', 'more'])
    if (remoteMore && this._user_infos.more != remoteMore && typeof remoteMore === 'object') {
      Utils.feedIfEmpty(this._user_infos.more, remoteMore);
    }

    Utils.bufferCookies(false);

    this._triggerInternalEvent('guest_init', { data: config }, false);
    if (
      Conversations.count > 0 ||
      (
        !this._users_default_disconnected &&
        Utils.deepGet(this._user_infos, ['more', 'kind']) == 'user'
      ) ||
      this._connect_every_guest
    ) {
      this._subscribeToChannel();
    }

    this._can_re_identify = true;
    this._ready = true;
    this._loaded = true;
    Diagnosis.step('guest-initialized', { name: this._guest_name });
  }

  _initTextsFromServerConfig(config) {
    this._triggerInternalEvent('texts_init', { data: config }, false);
  }

  _untilBodyIsAvailable() {
    return new Promise(async (resolve, reject) => {
      for (let i = 0 ; i < 10 ; i++) {
        if (document.body) resolve();
        else await Utils.delay(500);
      }
      reject();
    });
  }

  _initScriptInteractions() {
    // CLICK ON EXTERNAL LINK

    let externalLinks = Dom.findAll('parent', '.slaask-open-widget, .xeno-open-widget');
    let externalLinkById = Dom.findById('parent', 'slaask-open-widget');
    if (externalLinkById) externalLinks.push(externalLinkById);

    for (let i = 0; i < externalLinks.length; i++) {
      externalLinks[i].addEventListener("click", async (event) => {
        event.preventDefault()
        let viewName = Utils.dataSet(externalLinks[i], 'view');
        let viewState = Utils.dataSet(externalLinks[i], 'state') || undefined;
        if (viewState == "null") viewState = null;
        if (/^\d+$/.test(viewState)) viewState = ~~viewState;
        await Dom.showWidget({
          view: viewName,
          state: viewState,
          by: 'external_link',
          message: Utils.dataSet(externalLinks[i], 'message')
        })
      });
    }

    // CLICK ON BUTTON

    let buttonClickHandler = () => {
      if (Dom.hasClass('button', 'slaask-opened')) {
        Dom.hideWidget({ by: 'button_click' });
        Dom.get('button').element.setAttribute('aria-label', Wording.open_chatbox);
      } else {
        Dom.showWidget({ by: 'button_click' });
        Dom.get('button').element.setAttribute('aria-label', Wording.close_chatbox);
      }
    };

    if (this._loader && this._loader.proxy) {
      Dom.get('button').element.addEventListener("click", this._loader.proxy(buttonClickHandler));
    }
    else {
      Dom.get('button').element.addEventListener("click", buttonClickHandler);
    }

    // CLICK ON WIDGET CROSS

    Dom.get('widget').when('ready').then(() => {
      Dom.findById('widget', 'slaask-widget-header-cross').addEventListener("click", () => {
        Dom.hideWidget({ by: 'cross_click' })
      });

      const ephemeralHeaderBtn = Dom.findById('widget', 'slaask-widget-header-ephemeral');
      if (ephemeralHeaderBtn && this._ephemeral_conversations_enabled) {
        ephemeralHeaderBtn.addEventListener("click", () => {
          Conversations.setCurrentConversationEphemeral();
        });
      }

      Dom.findById('widget', 'slaask-widget-header-back').addEventListener("click", () => {
        const conv = Conversations.current;
        if (conv && conv.ephemeral && conv.id) {
          // End Daily call and remove iframe so user cannot return to the call
          const widgetWindow = Dom.get('widget') && Dom.get('widget').window;
          const callFrame = (widgetWindow && widgetWindow.callFrame) || (typeof window !== 'undefined' && window.top && window.top.callFrame);
          if (callFrame && typeof callFrame.leave === 'function') {
            try { callFrame.leave(); } catch (e) { /* ignore */ }
          }
          const iframeInfo = this._getDailyIframeInfo && this._getDailyIframeInfo();
          if (iframeInfo && iframeInfo.iframeView) {
            iframeInfo.iframeView.setContent('');
          }

          Ajax.call('/api/close_conversation', {
            key: this._api_key,
            token: this._guest_token,
            guest_token: this._guest_token,
            current_conversation_id: conv.id
          });
          Conversations.conversationClosed(conv, 'resolved', false);
          Conversations._syncConversationSummary(conv);
        }
        Views.jumpToPrevious();
      });

      Dom.findById('widget', 'slaask-menu-background-closer').addEventListener("click", (e) => {
        Dom.hideConversationMenu();
        Dom.hideEmojiContainer();
        Dom.hideGifsContainer();
      });

      if (Dom.menuHasOneFeature()) {
        Dom.findById('widget', 'slaask-paperclip').addEventListener("click", () => {
          Dom.hideEmojiContainer();
          Dom.hideGifsContainer();
          if (Dom.hasClass('widget', '#slaask-file-menu', 'slaask-opened')) Dom.hideConversationMenu();
          else Dom.showConversationMenu();
        });
      }

      if (Dom.findById('widget', 'slaask-emoji-button')) {
        Dom.findById('widget', 'slaask-emoji-button').addEventListener('click', () => {
          Dom.toggleEmojiContainer();
        });
      }

      if (Dom.findById('widget', 'slaask-gifs-button')) {
        Dom.findById('widget', 'slaask-gifs-button').addEventListener('click', () => {
          Dom.toggleGifsContainer();
        });
      }

      let gifSearch = () => {
        Utils.uniqueTimeout('gifs-search', () => {
          Dom.gifSearchQueryChanged();
        }, 300)
      };
      Dom.findById('widget', 'slaask-gifs-input').addEventListener('input', gifSearch);
      Dom.findById('widget', 'slaask-gifs-input').addEventListener('keyup', gifSearch);

      let emojiSearch = () => {
        EmojiPicker.filterBy(Dom.findById('widget', 'slaask-emojis-input').value)
      };
      Dom.findById('widget', 'slaask-emojis-input').addEventListener('input', emojiSearch);
      Dom.findById('widget', 'slaask-emojis-input').addEventListener('keyup', emojiSearch);

      let allEmojis = Dom.findAll('widget', '.slaask-emoji-item')

      for (var i = 0; i < allEmojis.length; i++) {
        allEmojis[i].addEventListener('click', (e) => {
          EmojiPicker.send(e.currentTarget.innerHTML)
          Dom.hideEmojiContainer()
        });
      }
    });

    let hideAlert = (event) => {
      event.preventDefault()
      Dom.addClass('alert', 'slaask-hidden');
      Dom.addClass('alert-overlay', 'slaask-hidden');
    };

    Dom.get('alert').when('ready').then(() => {
      Dom.findById('alert', 'slaask-alert-cancel').addEventListener("click", hideAlert);
      Dom.findById('alert', 'slaask-alert-header-cross').addEventListener("click", hideAlert);
    });

    Dom.get('alert-overlay').when('ready').then(() => {
      Dom.get('alert-overlay').element.addEventListener("click", hideAlert);
    });
  }

  _initFileSharing() {
    if (this._file_sharing_activated) {
      this._newConversationMenuButton(
        "file",
        "upload-file.svg",
        Wording.send_file,
        () => {
          Dom.findById('widget', 'slaask-file-input').click();
          Dom.hideConversationMenu();

        },
        '<input class="slaask-file-input" id="slaask-file-input" type="file">'
      );

      Dom.findById('widget', 'slaask-file-input').addEventListener('change', async (event) => {
        let fileInput = Dom.findById('widget', 'slaask-file-input');
        let file = event.currentTarget.files[0];

        if (file) {
          let filename  = fileInput.value.split('\\').pop();
          await Conversations.uploadFile(file, filename);
          fileInput.value = "";
        }
      });
    }

    if (this._sendscreenshot_enabled) {
      this._newConversationMenuButton(
        "screenshot",
        "upload-screenshot.svg",
        Wording.send_screenshot,
        () => {
          this._sendScreenshot(true, Dom.parent.document.location.hostname.indexOf('slaask.com') != -1);
          Dom.hideConversationMenu();
        }
      );
    }

    if (this._videochat_enabled) {
      this._newConversationMenuButton(
        "video",
        "video.svg",
        Wording.request_videochat,
        () => {
          Conversations.sendAskingforVideo('video_call');
          Dom.hideConversationMenu();
        }
      );
    }

    if (this._screensharing_enabled) {
      this._newConversationMenuButton(
        "screensharing",
        "screensharing.svg",
        Wording.request_screensharing,
        () => {
          Conversations.sendAskingforVideo('screen_sharing');
          Dom.hideConversationMenu();
        }
      );
    }

    if (this._chattranscript_enabled) {
      this._newConversationMenuButton(
        "transcript",
        "edit-3.svg",
        Wording.request_chattranscript,
        () => {
          Conversations.formChatTranscript();
          Dom.hideConversationMenu();
        }
      );
    }

    if (this._ephemeral_conversations_enabled) {
      this._newConversationMenuButton(
        "ephemeral",
        "ephemeral.svg",
        Wording.new_ephemeral_conversation_text,
        () => {
          Conversations.setCurrentConversationEphemeral();
          Dom.hideConversationMenu();
        }
      , '', ` title="${Wording.new_ephemeral_conversation_text_hint}"`);
    }

    Dom.findById('widget', 'slaask-send-input-trigger').addEventListener("click", (event) => {
      Conversations.submitOnlineForm();
      Dom.showFileSharingButton();
      Dom.findById('widget', 'slaask-input').focus();
      return false;
    });

  }

  _newConversationMenuButton(id, icon, name, action, addHtml, addParentHtml) {
    if (addHtml === undefined) addHtml = "";
    if (addParentHtml === undefined) addParentHtml = "";
    var menu = Dom.findById('widget', 'slaask-file-btns');
    menu.insertAdjacentHTML('beforeEnd', '<div id="slaask-file-btn-' + id + '" class="slaask-file-btn"' + addParentHtml + '><img src="' + this._cdn_url+ '/' + icon + '" alt="' + name + '" /><span class="slaask-file-btn-name">' + name + '</span>' + addHtml + '</div>');
    Dom.findById('widget', 'slaask-file-btn-' + id).onclick = action;
  }

  _initFormSubmit() {
    Dom.findById('widget', 'slaask-send-input-trigger').addEventListener( "load", (event) => {
      Dom.updateSendButton();
    });

    Dom.initAutoSize();

    let input = Dom.findById('widget', 'slaask-input');

    input.addEventListener('keyup', (event) => {
      let conversation = Conversations.current;
      if (!conversation.is_typing && input.value != '' && event.keyCode != 13 && conversation.id) {
        Ajax.call('/api/typing', { 'key': this._api_key, 'guest_token': this._guest_token, 'current_conversation_id': conversation.id, 'typing': true });
        conversation.is_typing = true
      }
      if (conversation.id) {
        Utils.uniqueTimeout('guest-typing-' + conversation.id, () => {
          Ajax.call('/api/typing', { 'key': this._api_key, 'guest_token': this._guest_token, 'current_conversation_id': conversation.id, 'typing': false });
          conversation.is_typing = false;
        }, 5000);
      }
    });

    input.addEventListener('change', (event) => {
      Utils.localStorage('typed-text', input.value)
    });

    if (Utils.localStorage('typed-text')) {
      Dom.showSendButton();
    }

    input.addEventListener('input', (event) => {
      Dom.updateSendButton();
    });

    input.addEventListener('keydown', (event) => {
      if (event.which == 13 && !event.shiftKey && !this._is_touch) {
        event.preventDefault();
        Conversations.submitOnlineForm();
      }
    });

    let widget = Dom.get('widget').element;
    let button = Dom.get('button').element;

    this._watchTouchDevice();

    input.addEventListener('paste', async (e) => {
      try {
        if (!this._file_sharing_activated) return false;
        if (!e.clipboardData) return false;
        var imgs = e.clipboardData.items;
        if (imgs == undefined) return false;
        for (var i = 0; i < imgs.length; i++) {
          if (imgs[i].kind != 'file') continue;
          var imgObj    = imgs[i].getAsFile();
          var filename  = imgObj.name;
          await Conversations.uploadFile(imgObj, filename);

          e.preventDefault();
        }
      } catch(e) {
        Utils.log(e);
      }
    });
  }

  _initTimeAgo() {
    Utils.uniqueInterval('time-ago', () => { this._slaaskTimeAgo(); }, 60000);
  }

  async _sendGuestInfo() {
    let data = {
      'user_infos': this._user_infos,
      'current_page': Dom.parent.location.href,
      'current_page_title': Dom.parent.document.title,
      'language': this._language,
      'platform': Platform
        ? Platform.os.family + ' (' + Platform.os.version + ')'
        : 'Unknown',
      'browser': Platform
        ? Platform.name + ' (' + Platform.version + ')'
        : 'Unknown',
      'timezone_offset': new Date().getTimezoneOffset()
    };

    if (!this._already_registered) {
      data['referrer'] = Dom.parent.document.referrer
    }

    if (this._stored_identify) {
      if (this._shared_storage_activated) {
        var anonymousToken = this._stored_information.anonymousId;
      } else {
        var anonymousToken = this._getOrGenerateCookieToken();
      }
      if (anonymousToken != this._guest_token) {
        data['previous_guest_token'] = anonymousToken;
      }
    }

    if (this._forced_user_group_id) {
      data['forced_user_group_id'] = this._forced_user_group_id
    }

    let ajaxData = await Ajax.call('/api/send_logs', data)
      .catch(response => { Diagnosis.error(response); throw response; });

    this._user_infos = ajaxData.user_infos;

    return ajaxData;
  }

  _isScriptOutOfDate(lastVersion) {
    return lastVersion != this._version && this._force_cache_last;
  }

  _reloadScript(lastVersion) {
    var slk = document.createElement('script');
    if (this._chat_file == 'debug') slk.src = this._cdn_url + '/chat_debug.js?v=' + lastVersion;
    else slk.src = this._cdn_url + '/chat.js?v=' + lastVersion;
    slk.type = 'text/javascript';
    slk.async = 'true';
    slk.onload = slk.onreadystatechange = () => {
      try {
        var rs = slk.readyState;
        if (rs && rs != 'complete' && rs != 'loaded') return;
      } catch (e) {}
      try {
        this._reloadApp();
      } catch (e) {
        Utils.log(e);
      }
    };
    var s = document.getElementsByTagName('script')[0];
    s.parentNode.insertBefore(slk, s);
  }

  _isWidgetEnabled() {
    if (this._force_loading) return true;

    const hideButton = this._disabled_on_mobile && (this.getScreenWidth() < this._mobile_threshold)

    return (this.isLive() == true || this._offline_mode != 'hidden') && !hideButton;
  }


  /* GUEST */

  _getEmail() {
    return Utils.deepGet(this._user_infos, ['more', 'email']) || null;
  }

  _setEmail(email) {
    Utils.deepSet(this._user_infos, ['more', 'email'], email);
  }


  /* OTHERS, NOT SORTED YET */

  _watchTouchDevice() {
    Dom.forEachWindowsAnticipated(win => {
      win.addEventListener('touchstart', event => { this._setTouchDeviceFromEvent(true); });
      win.addEventListener('mousemove', event => { this._setTouchDeviceFromEvent(false); });
    });
  }

  _setTouchDeviceFromEvent(isTouchDevice) {
    if (isTouchDevice !== this._is_touch) {
      // If device detected as touch device, we won't switch again for 2 seconds
      if ((new Date()).getTime() > this._is_touch_last_update + 2000) {
        this._setTouchDevice(isTouchDevice);
      }
    }
    if (isTouchDevice) {
      this._is_touch_last_update = (new Date()).getTime();
    }
  }

  _setTouchDevice(isTouchDevice) {
    Dom.when('ready').then(() => {
      if (isTouchDevice !== this._is_touch) {
        this._is_touch = !!isTouchDevice;
        Utils.localStorage('touch', this._is_touch);
        Dom.forEachWindowsAnticipated(win => {
          if (isTouchDevice) Utils.addClass(win.document.body, 'asktech-touch');
          else Utils.removeClass(win.document.body, 'asktech-touch');
        })
      }
    });
  }

  _initializeNotAnsweringDelay(conversation) {
    if (this._bot_tree_enabled) return;

    conversation.resetWaitingTimeout();

    let askingTime = conversation.conversation_answered ? this._email_asking_time_in_conv : this._email_asking_time;

    if (askingTime > 0) {
      conversation.setWaitingForAnswerTimeout(async () => {
        var infos = {
          'key': this._api_key,
          'token': this._guest_token,
          'current_conversation_id': conversation.id
        };
        let ajaxData = await Ajax.call('/api/check_away', infos);
        if (ajaxData.away && this.isLive()) this._askForEmailIfNotAnswering(conversation);
      }, askingTime);
    }
  }

  _askForEmailIfNotAnswering(conversation, localOnly = false, returnOnly = false) {
    if (this._bot_tree_enabled) return;

    if (!Conversations.warned_team_unavailable) {
      this._askForEmail(conversation, 'email_asking_content', 'email_asking_content_with_email', localOnly, returnOnly);
    }
  }

  _askForEmail(conversation, askWordingKey, askEmailKnownWordingKey, localOnly = false, returnOnly = false) {
    if (this._bot_tree_enabled) return;

    if (conversation.isOpened()) {
      let shouldAskEmail = !this._getEmail();

      if (shouldAskEmail || Wording.email_asking_content_with_email) {
        let askingTime = conversation.conversation_answered ? this._email_asking_time_in_conv : this._email_asking_time;
        let text = (shouldAskEmail ? Wording.md(askWordingKey) : Wording.md(askEmailKnownWordingKey));
        let plainText = (shouldAskEmail ? Wording[askWordingKey] : Wording[askEmailKnownWordingKey]);
        let html = shouldAskEmail
                    ? `
                      ${text}
                      <form class="slaask-not-answering-email">
                        <input name="email" class="slaask-input slaask-input-survey" placeholder="${Wording.email_placeholder_content.replace(/\"/g, "&quot;").replace(/\'/g, "&#39;")}" type="email" value="" required="required"/>
                        <input type="submit" class="slaask-btn" id="slaask-rating-sutmit" value="${Wording.email_submit_content.replace(/\"/g, "&quot;").replace(/\'/g, "&#39;")}"/>
                      </form>`
                    : text;

        let message = new Message(MS.bot);
        message.text = html;
        message.plain_text = text;
        message.addInteraction({
          selector: '.slaask-not-answering-email',
          event: 'submit',
          handler: e => {
            e.preventDefault();
            let email = e.currentTarget.email.value;
            this._setEmail(email);
            this._triggerInternalEvent('email_captured', {});
            Ajax.call('/api/update_visitor_email', {
              'key': this._api_key,
              'token': this._guest_token,
              'attr': 'email',
              'value': email,
              'email_asked': true
            });
            Conversations.removeElementsFromMessage(message, '.slaask-not-answering-email');
            conversation.addMessage(new Message(MS.visitor, email));
          }
        });

        if (!returnOnly)
          conversation.addMessage(message);

        if (!localOnly)
          Ajax.call('/api/away_warning', {
            'key': this._api_key,
            'token': this._guest_token,
            'text': this._askTechParser.parseMessageVariables(this._askTechParser.parseMessageMailto(plainText)),
            'email_asked': shouldAskEmail,
            'asking_time': askingTime,
            'conversation_id': conversation.id
          });

        return message;
      }
    }
    return null;
  }

  _askForScreenshot(show_widget, from_name, from_picture) {
    let conversation = Conversations.current;
    var screenshotQuestionHtml = Wording.md('screenshot_question') + '<input type="button" class="slaask-btn" value="' + Wording.button_value_yes + '"/><input type="button" class="slaask-btn" value="' + Wording.button_value_no + '"/><input type="hidden" value="" name="response"/>';

    let message = new Message(MS.bot, screenshotQuestionHtml);
    if (from_name)
      message.name = from_name;
    if (from_picture)
      message.image = from_picture;

    message.addInteraction({
      selector: '.slaask-btn',
      event: 'click',
      removeButtons: true,
      printResponse: e => e.currentTarget.value,
      handler: e => {
        let value = e.currentTarget.getAttribute('value')

        if (value == Wording.button_value_yes) {
          this._sendScreenshot(false, show_widget, from_name, from_picture);
        } else {
          Ajax.call('/api/upload_html', {
            'key': this._api_key,
            'guest_id': this._guest_id,
            'file_data': null,
            'current_conversation_id': Conversations.current.id
          });

          let message = new Message(MS.bot, Wording.md('screenshot_question_declined'));
          if (from_name)
            message.name = from_name;
          if (from_picture)
            message.image = from_picture;

          conversation.addMessage(message);
        }
      }
    });

    conversation.addMessage(message);
  }

  _sendScreenshot(user_triggered, show_widget, from_name, from_picture) {
    let conversation = Conversations.current;
    var html = Dom.parent.document.getElementsByTagName('html')[0].outerHTML;

    var keepScroll = (el, scroll) => {
      scroll.top = el.scrollTop;
      scroll.left = el.scrollLeft;
      scroll.children = [];
      if (el.children) {
        for (var i = 0 ; i < el.children.length ; i++) {
          if (el.children[i].tagName != 'SCRIPT') {
            scroll.children.push({});
            keepScroll(el.children[i], scroll.children[scroll.children.length - 1]);
          }
        }
      }
    };
    var keepCanvases = (doc, canvasesData) => {
      var canvases = doc.getElementsByTagName('canvas');
      for (var i = 0 ; i < canvases.length ; i++) {
        canvasesData.push(canvases[i].toDataURL());
      }
    };
    var keepInputs = (doc, inputsData) => {
      var inputs = doc.getElementsByTagName('input');
      for (var i = 0 ; i < inputs.length ; i++) {
        inputsData.push(inputs[i].type == "checkbox" || inputs[i].type == "radio" ? inputs[i].checked : inputs[i].value);
      }
    };

    let scrolls = {};
    keepScroll(Dom.parent.document.body, scrolls);

    var canvasesData = [];
    keepCanvases(Dom.parent.document, canvasesData);

    var inputsData = [];
    keepInputs(Dom.parent.document, inputsData);

    var iframesData = [];
    var iframes = Dom.findAll('parent', 'iframe');
    for (var i = 0 ; i < iframes.length ; i++) {
      try {
        var iframeDoc;
        if (iframes[i].contentDocument) {
          iframeDoc = iframes[i].contentDocument;
        }
        else if (iframes[i].contentWindow) {
          iframeDoc = iframes[i].contentWindow.document;
        }
        var iFrameCanvasesData = [];
        keepCanvases(iframeDoc, iFrameCanvasesData);
        var iFrameInputsData = [];
        keepInputs(iframeDoc, iFrameInputsData);
        if (iframeDoc.doctype) {
          var iframeDoctypeHtml = "<!DOCTYPE "
            + iframeDoc.doctype.name
            + (iframeDoc.doctype.publicId ? ' PUBLIC "' + iframeDoc.doctype.publicId + '"' : '')
            + (!iframeDoc.doctype.publicId && iframeDoc.doctype.systemId ? ' SYSTEM' : '')
            + (iframeDoc.doctype.systemId ? ' "' + iframeDoc.doctype.systemId + '"' : '')
            + '>';
        }
        else var iframeDoctypeHtml = "";
        iframesData.push({
          'html': iframeDoc.getElementsByTagName('html')[0].outerHTML,
          'src': iframeDoc.location.href,
          'doctype': iframeDoctypeHtml,
          'canvases_data': iFrameCanvasesData,
          'inputs_data': iFrameInputsData
        });
      }
      catch (e) {
        if(e.name !== "SecurityError") {
          throw e;
        }
      }
    }

    if (Dom.parent.document.doctype) {
      var doctypeHtml = "<!DOCTYPE "
        + Dom.parent.document.doctype.name
        + (Dom.parent.document.doctype.publicId ? ' PUBLIC "' + Dom.parent.document.doctype.publicId + '"' : '')
        + (!Dom.parent.document.doctype.publicId && Dom.parent.document.doctype.systemId ? ' SYSTEM' : '')
        + (Dom.parent.document.doctype.systemId ? ' "' + Dom.parent.document.doctype.systemId + '"' : '')
        + '>';
    }
    else var doctypeHtml = "";

    var url = Dom.find('parent', 'base');
    if (url) url = url.getAttribute('href');
    else url = Dom.parent.document.location.href;

    var css = "";
    for (var i = 0 ; i < Dom.parent.document.styleSheets.length ; i++) {
      var sheet = Dom.parent.document.styleSheets[i];
      try {
        if (sheet.cssRules) {
          for (var j = 0 ; j < sheet.cssRules.length ; j++) {
            css += sheet.cssRules[j].cssText;
          }
        }
      } catch (e) {
        // Sheet has no cssRules
      }
    }

    // Bot message
    let messageB = new Message(MS.bot,
                    user_triggered
                      ? Wording.md('screenshot_user_triggered')
                      : Wording.md('screenshot_user_not_triggered'));
    if (from_name)
      messageB.name = from_name;
    if (from_picture)
      messageB.image = from_picture;
    conversation.addMessage(messageB);

    // Visitor message
    let messageV = new Message(MS.visitor, Wording.uploading_screenshot + ' :cloud:');
    conversation.addMessage(messageV);

    Ajax.call('/api/upload_html', {
      'key': this._api_key,
      'guest_id': this._guest_id,
      'doctype': doctypeHtml,
      'show_widget': show_widget,
      "user_triggered": user_triggered,
      'url': url,
      'window_width': Dom.parent.innerWidth,
      'window_height': Dom.parent.innerHeight,
      'user_agent': window.navigator.userAgent,
      'file_data': html,
      'scrolls': scrolls,
      'css': css,
      'canvases_data': canvasesData,
      'inputs_data': inputsData,
      'iframes_data': iframesData,
      'filename': "Screenshot" + (new Date()).getTime() + ".html",
      'message_hash': messageV.hash,
      'current_conversation_id': conversation.id
    });
  }

  _subscribeToChannel(group_id, wsEnabled = true) {
    let team = group_id
                ? Teams.findOrDefault(group_id)
                : null;

    // Sometimes, pusher is not needed
    let websocketNeeded =  !(this._ticketing_system_enabled || this._handle_delayed_by_email) ||
                        team ||
                        this.isLive() ||
                        this._bot_tree_enabled ||
                        Conversations.unresolvedConversationsCount('one') > 0;
    if (!websocketNeeded) return;
    
    Utils.queue(this._websocket_version, (resolve, reject) => {
      // Allow re-initializing _websocketClient when a transport upgrade to WebSocket is requested
      const setupWebsocketChannels = () => {
        /* INIT CONNECTION TIMEOUT */

        let inactivityTimeout = null;

        const startTimeout = () => {
          if (inactivityTimeout) this._clearTimeout(inactivityTimeout);
          let keepAliveTime = Conversations.hasLive() ? 1000 * 60 * 120 : 1000 * 60 * 30;
          inactivityTimeout = this._setTimeout(() => {
            this._disconnectChatbox();
          }, keepAliveTime);
        };

        const stopTimeout = () => {
          if (inactivityTimeout) {
            this._clearTimeout(inactivityTimeout);
            inactivityTimeout = null;
          }
        };

        Dom.on('tab-hidden', startTimeout).until(this, 'chatbox-disconnected');
        Dom.on('tab-visible', stopTimeout).until(this, 'chatbox-disconnected');
  
        if (Dom.isTabVisible() === false) startTimeout();
  
        /* INIT MAIN & PRESENCE CHANNELS */
  
        // let socketName, mainChannel, presenceChannel, globalPresenceChannel;
        let socketName, mainChannel, presenceChannel;

        if (!team) {
          socketName            = ' '
          mainChannel           = this._websocketClient.subscribe(this._api_key + '-' + this._api_ws_token);
          if (this._websocket_version === 'pusher') {
            presenceChannel       = this._websocketClient.subscribe('presence-' + this._api_key + '-' + this._api_ws_token);
            this._presence_channel  = presenceChannel;
          }
        } else {
          socketName      = ' Many-To-Many '
          mainChannel     = this._websocketClient.subscribe(this._api_key + '-' + group_id);
          if (this._websocket_version === 'pusher') {
            presenceChannel = this._websocketClient.subscribe('presence-' + this._api_key + '-' + group_id);
            this._presence_channel  = presenceChannel;
          }
        }
  
        let presenceChannelEvents = {
          'pusher:subscription_succeeded': m => {
            Utils.log('Client connected to the' + socketName + 'presence server.');
            if (team) team.online_count = m.count;
          },
  
          'pusher:member_added': member => {
            if (team) team.online_count = team.online_count + 1;
          },
  
          'pusher:member_removed': member => {
            if (team) team.online_count = team.online_count - 1;
          }
        };

        const chunkBuffers = {};
  
        let mainChannelEvents = {
          'pusher:subscription_succeeded': m => {
            Utils.log('Client connected to the' + socketName + 'socket server.');
          },
  
          'new_message': m => {
            Conversations.newIncomingMessage(m);
          },
  
          'deleted_conversation': m => {
            Conversations.deleteConversation(m)
          },
  
          'edited_message': m => {
            Conversations.editMessageFromId(m.message_id, m.text, m.translated);
          },
  
          'moderated_message': () => {
            Conversations.moderateLastGuestMessage();
          },
  
          'add_text_to_message': m => {
            if (!chunkBuffers[m.message_id]) {
              chunkBuffers[m.message_id] = { buffer: {}, nextIndex: 0 };
            }
            
            const state = chunkBuffers[m.message_id];
            state.buffer[m.index] = m.chunk;
            
            while (state.buffer[state.nextIndex] !== undefined) {
              Conversations.addTextToMessageFromId(m.message_id, state.buffer[state.nextIndex]);
              delete state.buffer[state.nextIndex];
              state.nextIndex++;
            }

            // Conversations.addTextToMessageFromId(m.message_id, m.chunk);
          },
  
          'deleted_message': m => {
            Conversations.removeMessageFromId(m.message_id);
          },
  
          'destroy_attachments': m => {
            if (m.attachments_id) {
              Message.get(m.message_id).removeAttachmentsFromId(m.attachments_id)
            }
            else {
              Message.get(m.message_id).removeEphemeralAttachments()
            }
          },
  
          'hash_callback': m => {
            this._trigger('hash_callback', m);
          },
  
          'hide_message_input': m => {
            this._trigger('hide_message_input', m);
          },
  
          'show_message_input': m => {
            this._trigger('show_message_input', m);
          },
  
          'redirection': m => {
            Conversations.forEach((conversation) => {
              conversation.resetWaitingTimeout();
            });
            this._redirectToUrl(m.url, m.target);
          },
  
          'notification': m => {
            if (!Utils.defined(m.conversation_id)) {
              Utils.error("Missing conversation_id"); Utils.log(m); return;
            }
  
            let conversation = Conversations.get(m.conversation_id);
            conversation.resetWaitingTimeout();
            let prechat_question;
            let message;
            switch(m.sub_type) {
              case 'end_conversation':
                Conversations.conversationClosed(Conversations.get(m.conversation_id), m.status);
                break;

              case 'analysis_summary':
                Conversations.applyAnalysisSummary(conversation, m.summary);
                break;
  
              case 'conversation_reopened':
                Conversations.conversationReopened(Conversations.get(m.conversation_id), m.status);
                break;
  
              case 'start_survey':
                Utils.warn('Feature disabled temporarily');
                // Surveys.processNextSurvey()
                break;
  
              /*X*/case 'many_alert':
                message = new Message(MS.agent, m.text);
                message.image = m.picture;
                message.name = m.from_name;
                Triggers.sendManyToSlackAlert(message)
                break;
  
              /*X*/case 'stop_many_alert':
                Triggers.stopManyToSlackAlert()
                break;
  
              case 'ask':
                prechat_question = m
  
                let type = 'text';
                if (~prechat_question.attr.indexOf('|')) {
                  type = ({
                    "string": "text",
                    "date": "date",
                    "integer": "number",
                    "boolean": "boolean"
                  })[prechat_question.attr.split('|')[1]] || '';
                }
                else {
                  type = prechat_question.attr == 'email' ? 'email' : 'text';
                }
  
                Prechat.renderCustomQuestion(
                  m.conversation_id,
                  type,
                  prechat_question.attr.split('|')[0].replace(/_/g, ' '),
                  prechat_question.question,
                  m
                )
  
                .then(response => {
                  let changedAttr = {};
                  changedAttr[prechat_question.attr] = response;
                  this.updateVisitorInfos(changedAttr);
                });
  
                break;
  
              default:
                message = new Message(MS.bot, m.text);
                conversation.addMessage(message);
                break;
            }
          },
  
          'user_typing': m => {
            if (!Utils.defined(m.conversation_id)) {
              Utils.error("Missing conversation_id"); Utils.log(m); return;
            }
  
            let conversation = Conversations.get(m.conversation_id);
            conversation.resetWaitingTimeout();
            conversation.addUserTyping(m);
          },
  
          'user_stopped_typing': m => {
            if (!Utils.defined(m.conversation_id)) {
              Utils.error("Missing conversation_id"); Utils.log(m); return;
            }
  
            let conversation = Conversations.get(m.conversation_id);
            conversation.resetWaitingTimeout();
            Conversations.get(m.conversation_id).removeUserTyping(m);
          },
  
          'message_read': m => {
            // In some cases, the message in not marked as read.
            // This will lead to confusions, the visitor will think nobody read his message.
            Utils.warn("message_read: Feature disabled until it is fully functionnal on server side");
            // let message = Conversations.get(m.conversation_id).getMessage(m.message_id);
            // message.status = 3;
            // Conversations.updateMessageDisplayedStatus(message);
          },
  
          'file_uploaded': m => {
            Conversations.renderFileUploaded(m.text, m.message_hash, m.conversation_id, m.new_conversation_id)
          },
  
          'screenshot_request': m => {
            this._askForScreenshot(m.show_widget, m.name, m.picture);
          },
  
          'bot_tree_state_change': m => {
            const conversation = Conversations.get(m.conversation_id);
            if (conversation) {
              conversation.bot_tree_running = m.running;
            }
          }
        };
  
        Object.keys(mainChannelEvents).forEach(event => {
          let handler = mainChannelEvents[event];

          mainChannel.bind(event, handler);
        });
  
        if (this._websocket_version === 'pusher') {
          Object.keys(presenceChannelEvents).forEach(event => {
            let handler = presenceChannelEvents[event];
            presenceChannel.bind(event, handler);
          });
        }
      }

      if (this._websocketConnecting) {
        resolve();
        return;
      }

      let websocketInitialized = !!this._websocketClient;
      let wsUpgrade = !this._websocketClientEnabled && wsEnabled;
      if (websocketInitialized && !wsUpgrade) {
        resolve();
        return;
      }

      /* INIT WEBSOCKET CONNECTIONS */

      let websocketClient

      this._websocketConnecting = true;

      if (this._websocket_version === 'askws') {
        websocketClient = new AskWS({
          host: this._websocket_url,
          appKey: this._realtime_token,
          encrypted: this._encrypted_websocket, // or true for wss
          autoReconnect: true,
          getToken: () => {
            return Ajax.call('/api/websocket_token', {
              'api_key': this._api_key,
              'token': this._api_ws_token
            }).then(response => {
              return response.token;
            });
          }
        });

        this._websocketClient = websocketClient;

        this._websocketClient.bind('connection_established', (data) => {
          this._eventHappened('ws_connected');

          if (this._reconnecting) {
            Utils.warn('[AskWS] WebSocket reconnected after disconnect/bfcache');
            this._handleFullReconnected();
            Conversations.syncMissedMessages();
          }
          
          // Only setup channels on initial connection, not on reconnects
          // Channels are automatically resubscribed by askws on reconnect
          if (!this._websocketClientEnabled) {
            setupWebsocketChannels();
          }

          this._websocketClientEnabled  = wsEnabled;
          this._websocketConnecting = false;

          resolve();
          return;
        });

        this._websocketClient.bind('disconnected', (data) => {
          Utils.warn('[AskWS] Disconnected (code: ' + data.code + ', reason: "' + data.reason + '", wasClean: ' + data.wasClean + ')');
          this._handleReconnecting();
        });

        this._websocketClient.bind('error', (data) => {
          this._handleReconnecting();
        });

        this._websocketClient.bind('bfcache_suspend', (data) => {
          Utils.warn('[AskWS] bfcache: page cached, suspending WebSocket (previous state: ' + data.previous_state + ')');
          this._handleReconnecting();
        });

        this._websocketClient.bind('bfcache_resume', (data) => {
          Utils.warn('[AskWS] bfcache: page restored, forcing reconnect (reason: ' + data.reason + ')');
          this._handleReconnecting();
        });

        this._websocketClient.bind('reconnecting', (data) => {
          Utils.log('[AskWS] Reconnecting after disconnect', data);
        });

        // AskWS gave up retrying: show the reconnect button instead of an endless
        // "reconnecting" banner (AskWS still reconnects on its own when the page
        // becomes visible again or the network comes back)
        this._websocketClient.bind('reconnect_failed', (data) => {
          Utils.warn('[AskWS] Gave up reconnecting after ' + data.attempts + ' attempts');
          this._disconnectChatbox();
        });
        
        this._websocketClient.connect()
      } else {
          // Prevent pusher from selecting the last transport by default
        window.localStorage.removeItem('pusherTransportEncrypted');

        const disabledTransports = wsEnabled ? [] : ['ws', 'wss'];

        websocketClient = new Pusher(this._realtime_token, {
          encrypted: true,
          authEndpoint: this._post_url + '/api/renew_websocket_token?token=' + this._api_ws_token,
          disabledTransports: disabledTransports,
          cluster: 'eu',
          activity_timeout: 30000
        });

        websocketClient.connection.bind('state_change', (m) => {
          if (this._destroyed) return;

          if (m.previous == "connected" && m.current == "connecting") {
            this._handleReconnecting();
          }
          else if (m.previous == "connecting" && m.current == "connected") {
            this._websocketConnecting = false;

            if (!this._websocketClientEnabled) {
              setupWebsocketChannels();
            }

            if (this._reconnecting) {
              this._handleFullReconnected();
              Conversations.syncMissedMessages();
            }
            else {
              // if (this._websocketClient) this._websocketClient.disconnect();
              this._websocketClient         = websocketClient;
              this._websocketClientEnabled  = wsEnabled;
              this._eventHappened('ws_connected');
              resolve();
            }
          }
        });
        
        this._websocketClient = websocketClient;
        this._websocketConnecting = false;
      }
    });
  }

  _handleReconnecting() {
    if (this._destroyed) return;

    if (!this._reconnecting) {
      this._reconnecting = true;
      Dom.get('widget').when('ready', () => {
        if (this._destroyed) return;
        Dom.find('widget', '#asktech-reconnecting .asktech-disconnected').style.display = '';
        Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-subtitle').style.display = '';
        Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-pulser').style.display = '';
        Dom.find('widget', '#asktech-reconnecting .asktech-reconnected').style.display = 'none';
        Dom.addClass('widget', 'asktech-widget-reconnecting');
      });
    }
  }

  _handleReconnected() {
    if (this._destroyed) return;

    if (this._reconnecting) {
      this._reconnecting = false;
      this._disconnectChatbox();
    }
  }

  _handleFullReconnected() {
    if (this._destroyed) return;

    this._reconnecting = false;
    Dom.get('widget').when('ready', () => {
      if (this._destroyed) return;
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected').style.display = 'none';
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-subtitle').style.display = 'none';
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-pulser').style.display = 'none';
      Dom.find('widget', '#asktech-reconnecting .asktech-reconnected').style.display = 'none';
      Dom.removeClass('widget', 'asktech-widget-reconnecting');
    });
  }

  _disconnectChatbox() {
    if (this._destroyed) return;

    Dom.get('widget').when('ready', () => {
      if (this._destroyed) return;
      let button = Dom.find('widget', '#asktech-reconnecting .asktech-reconnecting-button');
      button.style.backgroundColor = this._window_color;
      button.style.color = this._title_color;
      this._registerEvent(button, 'click', () => {
        this._handleFullReconnected();
        this._reloadApp();
      });
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected').style.display = '';
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-subtitle').style.display = 'none';
      Dom.find('widget', '#asktech-reconnecting .asktech-disconnected .asktech-reconnecting-pulser').style.display = 'none';
      Dom.find('widget', '#asktech-reconnecting .asktech-reconnected').style.display = '';
      Dom.addClass('widget', 'asktech-widget-reconnecting');
    });
    if (this._websocketClient && this._websocket_version != 'askws') this._websocketClient.disconnect();
    this._trigger('chatbox-disconnected');
  }

  // USER GROUPS

  /*X*/_setManyToManyChannel(conversation) {
    let team = conversation.team;
    if(team.kind == 'many') {

      let send_data     = {
        'key': this._api_key,
        'token': this._guest_token,
        'message': ' ',
        'no_message': true,
        'user_group_id': team.id,
        'no_database_saving': true, // Note: Parameter dropped
        'current_conversation_id': conversation.id
      };

      Ajax.call('/api/publish', send_data);

      if (this._user_group_alert_message != null && this._user_group_alert_message != 'null') {
        let message = new Message(MS.bot, this._user_group_alert_message);
        Triggers.sendManyToSlackAlert(message)
      }

      if (this._websocketClient) { this._websocketClient.disconnect(); }

      team.online_count = this._agents_members_count;

      this._subscribeToChannel(team.id)
      let convView = Views.getByName('conversation');
      Dom.addClass('widget', convView.element, 'slaask-widget-view-conversation-with-notify');
      Dom.addClass('widget', '#slaask-input', 'hide-paperclip');
      // Utils.removeClass('slaask-widget-notify-container', 'slaask-hidden');
      convView.scrollToBottom();
    }
  }

  /*X*/_removeManyToManyChannel() {
    if(this._user_group_kind == 'many') {
      let send_data     = {
        'key': this._api_key,
        'token': this._guest_token,
        'message': ' ',
        'no_message': true,
        'user_group_id': null,
        'no_database_saving': true, // Note: Parameter dropped
        'current_conversation_id': Conversations.current.id
      };

      this._user_group_kind = 'one'
      this._user_group_id   = null

      Ajax.call('/api/publish', send_data);

      if (this._websocketClient) { this._websocketClient.disconnect(); }
      if (this._manual_messages_activated) {
        this._subscribeToChannel()
      }

      this._members_count = this._agents_members_count

      let convView = Views.getByName('conversation');
      Dom.removeClass('widget', convView.element, 'slaask-widget-view-conversation-with-notify');
      Dom.removeClass('widget', convView.element, 'slaask-widget-view-conversation-with-notify-alert');
      Dom.removeClass('widget', '#slaask-input', 'hide-paperclip');
      Dom.addClass('widget', '#slaask-widget-notify-container', 'slaask-hidden');
      Dom.addClass('widget', '#slaask-widget-notify-alert-container', 'slaask-hidden');

      convView.scrollToBottom()

      // this._conversation_closed = true

      Dom.findById('widget', 'slaask-widget-header-back').removeEventListener('click', this._removeManyToManyChannel)
    }
  }

  /*X*/_setOneToSlackChannel() {
    this._subscribeToChannel();
    Dom.addClass('widget', Views.getByName('conversation').element, 'slaask-widget-view-conversation-with-notify');
    Dom.addClass('widget', '#slaask-widget-notify-title-span', 'slaask-hidden');
  }

  _renderActionLink(action_link) {
    if(action_link && action_link.link != '' && action_link.text != '') {
      return '<a class="slaask-btn" href="' + action_link.link + '" target="_blank">' + action_link.text + '</a>';
    } else {
      return '';
    }
  }

  _redirectToUrl(url, target) {
    var expression = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,4}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/i;
    var regex = new RegExp(expression);
    var res;

    if(url.indexOf('|') != -1) {
      url = url.substring(0, url.indexOf('|'))
    }

    if (!url.match(regex)) {
      url = 'http://' + url
    }

    if (target == 'blank') {
      res = Dom.parent.open(url);
    } else {
      Dom.parent.location = url
    }
  }


  // *******************
  // **** JS EVENTS ****
  // *******************

  _triggerInternalEvent(event_name, options, logObject) {
    if (typeof logObject == "undefined") logObject = true;
    this._triggerAnalyticEvent(`${this._guessBrand()}.${event_name}`, options)

    try {
      Utils.log('Event "' + event_name + '" trigerred ' + (logObject ? JSON.stringify({ 'detail': options }) : ''))
      this._trigger(event_name, options);

      try {
        ['xeno', 'slaask', 'sarbacane', 'polaria'].forEach((brand) => {
          let event = new CustomEvent(brand + '.' + event_name, { detail: options });
          Dom.parent.document.dispatchEvent(event);
        })
      } catch (e) {}
    }
    catch (e) {
      Utils.error(e);
    }
  }

  // **************************
  // **** ANALYTICS EVENTS ****
  // **************************

  _triggerAnalyticEvent(event_name, options) {
    try {
      if (event_name == `${this._guessBrand()}.ready`) { return }
      event_name = event_name.replace('.', '.widget.')
      for(var i = 0; i < this._analytics_keys.length; i++) {
        switch(this._analytics_keys[i].name) {
          case 'Mixpanel':
            Dom.parent.mixpanel.init(this._analytics_keys[i].key);

            if (this._user_infos && this._user_infos['more'] && this._user_infos['more']['id'] != null) {
              Dom.parent.mixpanel.identify(this._user_infos['more']['id'])
            } else {
              if (this._user_infos && this._user_infos['more'] && this._user_infos['more']['user_id'] != null) {
                Dom.parent.mixpanel.identify(this._user_infos['more']['user_id'])
              } else {
                Dom.parent.mixpanel.identify(this._guest_token)
              }
            }

            Dom.parent.mixpanel.track(
              event_name,
              options
            );
            break;

          case 'Google Analytics':
            try {
              Dom.parent.gtag('event', event_name, { 'event_category': this._guessBrand(), 'event_label': options.event_label ? options.event_label : Utils.humanize(event_name.replace('.', ' ')).split(' ').join('') });
            } catch (e) {
              if (this._chat_file == "debug") Utils.publicLog('Google Analytics is not defined on this page');
              else Utils.publicLog(e);
            }
            break;

          case 'Facebook Pixel':
            try {
              Dom.parent.fbq(['track', Utils.humanize(event_name.replace('.', ' ')).split(' ').join(''), this._fb_infos]);
            } catch (e) {
              if (this._chat_file == "debug") Utils.publicLog('Facebook Pixel is not defined on this page');
              else Utils.publicLog(e);
            }
            break;
        }
      }
    } catch (e) {
      Utils.publicLog(e);
    }
  }

  _startVideoConference(video_kind, from_name, provider, url) {
    if (provider == 'atlassian') { this._startAtlassianVideoConference(video_kind, from_name) }
    else if (provider == 'confrere') { this._startConfrereVideoConference(url) }
    else { this._startConfrereVideoConference(url, from_name) }
  }

  _startConfrereVideoConference(url, name) {
    if (url) {
      Views.jumpToViewByName('video-chat', url);
    }
  }

  _startAtlassianVideoConference(video_kind, from_name) {
    let conversation = Conversations.current;

    if(this.getScreenWidth() < this._mobile_threshold) { this.hide() }
    var atlassianScript = this.createScriptTag('https://atlassian.video/external_api.js');

    atlassianScript.onload = () => {
      var domain  = 'atlassian.video';
      var room    = 'slaask-' + this._api_key + '-' + this._guest_token;

      var videoIframe = document.createElement("DIV");

      Dom.switchFooter('footer');

      videoIframe.className = 'slaask-video-container';

      Views.getByName('conversation').element.appendChild(videoIframe);

      var configOverride = {
        enableRecording: 0
      }

      var interfaceConfigOverwrite = {
        TOOLBAR_BUTTONS: ['microphone', 'camera', 'desktop', 'invite', 'fullscreen', 'hangup', 'etherpad', 'sharedvideo', 'sip', 'dialpad', 'settings'],
        DEFAULT_REMOTE_DISPLAY_NAME: '"' + this._guest_name.split("-#")[0] + '"',
      };

      var api = new JitsiMeetExternalAPI(domain,
        room,
        undefined,
        undefined,
        videoIframe,
        configOverride,
        interfaceConfigOverwrite);

      if (Utils.deepGet(this._user_infos, ['more', 'avatar']) != null) {
        api.executeCommand('avatarUrl', this._user_infos['more']['avatar'])
      }

      if (video_kind == 'screensharing') {
        api.executeCommand('toggleChat')
      }

      api.executeCommand('toggleVideo')
      api.executeCommand('toggleAudio')

      api.addEventListener('readyToClose', () => {
        Utils.removeElement(Dom.find('widget', '.slaask-video-container'));
        Dom.switchFooter('input');
        let message     = new Message(MS.bot);
        message.text    = 'Video call ended.';
        conversation.addMessage(message);
      })
    }
  }

  _isVideoChatUrl(url) {
    const match = url.match(/https?:\/\/([^/]+)/);
    return match && match[1] == this._video_chat_domain;
  }

  _getDailyIframeInfo() {
    try {
      const iframeView = Views.getByName('iframe');
      if (!iframeView) return null;
      
      const iframe = iframeView._iframe;
      if (!iframe || !iframe.isConnected) return null;
      
      const url = iframe.src || iframeView.getState();
      if (!url) return null;
      
      const isDailyVideo = this._isVideoChatUrl(url) || (url && url.indexOf('videochat_join_guest') !== -1);
      if (!isDailyVideo) return null;
      
      return { iframe, url, iframeView };
    } catch(e) {
      return null;
    }
  }

  _updateVideoCallButton() {
    try {
      const videoCallButton = Dom.findById('widget', 'slaask-widget-header-video-call');
      if (!videoCallButton) return;
      
      const isInIframeView = Views.current && Views.current.name === 'iframe';
      if (isInIframeView) {
        Dom.addClass('widget', videoCallButton, 'slaask-hidden');
        return;
      }
      
      const iframeInfo = this._getDailyIframeInfo();
      if (iframeInfo) {
        Dom.removeClass('widget', videoCallButton, 'slaask-hidden');
      } else {
        Dom.addClass('widget', videoCallButton, 'slaask-hidden');
      }
    } catch(e) {
    }
  }

  _returnToDailyCall() {
    const iframeInfo = this._getDailyIframeInfo();
    if (iframeInfo && iframeInfo.url) {
      Views.jumpToViewByName('iframe', iframeInfo.url);
    }
  }

  _isHelpCenterUrl(url) {
    return url.split('/hc/')[0].replace(/https?:\/\//, '') == this._help_center_url.replace(/https?:\/\//, '');
  }

  _isMeetingsUrl(url) {
    const urlWithoutProtocol = url.replace(/^\w+:\/\//, '');
    const baseUrlWithoutProtocol = this._meetings_base_url.replace(/^\w+:\/\//, '');
    return baseUrlWithoutProtocol == urlWithoutProtocol.substr(0, baseUrlWithoutProtocol.length);
  }

  _createTimeAgo(element, ts) {
    let time = Utils.exists(ts) ? ts : Math.floor(new Date() / 1000);
    element = Utils.exists(element) ? element : document.createElement('span');
    Utils.addClass(element, 'slaasktimeago');
    Utils.addClass(element, 'slaask-widget-convpage-conversation-time');
    Utils.dataSet(element, 'datetime', time);
    this._slaaskTimeAgo(element);
    return element;
  }

  _slaaskTimeAgo(element) {

    var templates = {
      prefix: Wording.time_prefix,
      suffix: Wording.time_suffix,
      seconds: Wording.time_seconds,
      minute: Wording.time_minute,
      minutes: Wording.time_minutes,
      hour: Wording.time_hour,
      hours: Wording.time_hours,
      day: Wording.time_day,
      days: Wording.time_days,
      month: Wording.time_month,
      months: Wording.time_months,
      year: Wording.time_year,
      years: Wording.time_years
    };

    var template = (t, n) => {
      return templates[t] && templates[t].replace(/%d/i, Math.abs(Math.round(n)));
    };

    var timer = (time) => {
      if (!time)
        return;
      time = time.replace(/\.\d+/, ""); // remove milliseconds
      time = time.replace(/-/, "/").replace(/-/, "/");
      time = time.replace(/T/, " ").replace(/Z/, " UTC");
      time = time.replace(/([\+\-]\d\d)\:?(\d\d)/, " $1$2"); // -04:00 -> -0400
      time = new Date(time * 1000 || time);

      var now = new Date();
      var seconds = ((now.getTime() - time) * .001) >> 0;
      var minutes = seconds / 60;
      var hours = minutes / 60;
      var days = hours / 24;
      var years = days / 365;

      return templates.prefix + (
        seconds < 45 && template('seconds', seconds) ||
        seconds < 90 && template('minute', 1) ||
        minutes < 45 && template('minutes', minutes) ||
        minutes < 90 && template('hour', 1) ||
        hours < 24 && template('hours', hours) ||
        hours < 42 && template('day', 1) ||
        days < 30 && template('days', days) ||
        days < 45 && template('month', 1) ||
        days < 365 && template('months', days / 30) ||
        years < 1.5 && template('year', 1) ||
        template('years', years)
      ) + templates.suffix;
    };

    var elements = [];
    if (element) {
      elements = [element];
    }
    else {
      Dom.forEachWindows(win => {
        Utils.forEach(win.document.getElementsByClassName('slaasktimeago'), el => {
          elements.push(el);
        });
      });
    }
    for (var i = 0 ; i < elements.length ; i++) {
      var $this = elements[i];
      if (typeof $this === 'object') {
        $this.innerHTML = timer($this.getAttribute('title') || Utils.dataSet($this, 'datetime') || $this.innerHTML);
      }
    }
  }


  /* COOKIES / STORAGE */

  _getOrGenerateCookieToken(api_key) {
    let settings = this._settings;
    api_key = api_key || this._api_key;

    if (settings && settings.anonymousToken) return settings.anonymousToken;

    if (settings && settings.noCookie) {
      let token = this._cookies_fallback['slaask-token-' + api_key];
      if (token) {
        return token;
      }
      else {
        return this._cookies_fallback['slaask-token-' + api_key] = Utils.generateRandomToken();
      }
    }
    else {
      let token = Utils.getCookie('slaask-token-' + api_key);
      if (token != "") {
        return token
      } else {
        try {
          let shouldOverrideCookie = Utils.shouldOverrideCookie()
          if (shouldOverrideCookie) {
            return Utils.setCookie('slaask-token-' + api_key, shouldOverrideCookie, 380);
          } else {
            return Utils.setCookie('slaask-token-' + api_key, Utils.generateRandomToken(), 380);
          }
        } catch(e) {
          return Utils.setCookie('slaask-token-' + api_key, Utils.generateRandomToken(), 380);
        }
      }
    }
  }

  _hasCookieMessage() {
    var token = Utils.getCookie('slaask-message-' + this._api_key);
    return token != "" ? true : false;
  }

  _sharedStorage(key, value = false) {
    if (this._ask_tech_shared_storage) {
      return this._ask_tech_shared_storage.onConnect().then(() => {
        if (value) {
          return this._ask_tech_shared_storage.set(key, JSON.stringify(value));
        } else {
          return this._ask_tech_shared_storage.get(key);
        }
      })
      .then(result => result ? JSON.parse(result) : null)
      .catch(error => {
        if (error.message == 'Invalid permissions for get') {
          Utils.publicWarn(`Can't access to ${this._guessBrand()} session vault. Unauthorized host.`);
        } else {
          Utils.publicWarn(error);
        }
        this._ask_tech_shared_storage = false
        return Utils.localStorage(key, value)
      })
    } else {
      return new Promise((resolve, reject) => {
        resolve(Utils.localStorage(key, value))
      })
    }
  }


  /* PARSE */

  _askTechParserPageContext() {
    try {
      return {
        pageHostname: Dom.parent.location.hostname,
        pageHref: Dom.parent.location.href
      };
    } catch (e) {
      return {};
    }
  }

  // Only for external use (retro compatibility)
  mdToHtml(markdown, plain = false) {
    let askTechParser = Utils.cacheSync('parser', 'generic', () => {
      let askTechParser = new AskTechParser();
      askTechParser.config(Object.assign({
        userInfos: {},
        users: [],
        cdnUrl: this._cdn_url,
        drawImages: true,
        piiTokens: this._pii_tokens
      }, this._askTechParserPageContext()));
      return askTechParser;
    });

    return askTechParser.mdToHtml(markdown, plain);
  }

  // Only for external use (retro compatibility)
  htmlToDisplayable(html, plain = false, userInfos = this._user_infos) {
    let askTechParser = Utils.cacheSync('parser', userInfos.display_name, () => {
      let askTechParser = new AskTechParser();
      askTechParser.config(Object.assign({
        userInfos: userInfos,
        users: [],
        cdnUrl: this._cdn_url,
        drawImages: true,
        piiTokens: this._pii_tokens
      }, this._askTechParserPageContext()));
      return askTechParser;
    });

    return askTechParser.htmlToDisplayable(html, plain);
  }

  // Retro compatibility
  _parseMessageHtml(text, noEmbedly, noVariables) {
    if (text == null) { return '' }
    text   = this._askTechParser.parseMessageMailto(text);
    if (noVariables == null) {
      text = this._askTechParser.parseMessageVariables(text);
    }
    text   = this._askTechParser.LightMarkdown.toHtml(text, noEmbedly);
    text   = this._askTechParser.parseMessageAtUsers(text);
    return text;
  }

  get _settings() {
    return Dom.parent._xenoSettings || Dom.parent._slaaskSettings || Dom.parent._sarbacaneSettings || Dom.parent._polariaSettings;
  }

  get _loader() {
    return Dom.parent._xenoLoader || Dom.parent._slaaskLoader || Dom.parent._sarbacaneLoader || Dom.parent._polariaLoader;
  }

  get _brand() {
    return this._guessBrand()
  }

  /**
   * Uses many parameters to determine the brand name
   * @return {string} "xeno", "slaask", "sarbacane" or "polaria"
   */
  _guessBrand() {
    try {
      let xeno = "xeno";
      let slaask = "slaask";
      let sarbacane = "sarbacane";
      let polaria = "polaria";
      if (Dom.parent._sarbacaneSettings) return sarbacane;
      if (Dom.parent._polariaSettings) return polaria;
      if (Dom.parent._polariaLoader) return polaria;
      if (this._xeno !== null && typeof this._xeno != "undefined") {
        if (this._xeno) return xeno;
        else return slaask;
      } else {
        if (Dom.parent._xenoSettings) return xeno;
        if (Dom.parent._slaaskSettings) return slaask;
        if (Dom.parent._xenoLoader) return xeno;
        if (Dom.parent._slaaskLoader) return slaask;
        return Utils.cacheSync('brand_guess', 'scripts', () => {
          let scripts = Dom.parent.document.getElementsByTagName('script');
          let result = slaask;
          Utils.forEach(scripts, script => {
            if (/https?:\/\/cdn\.xeno\.app/.test(script.src)) result = xeno;
          });
          return result;
        });
      }
    } catch(e) {
      return "slaask";
    }
  }

  /**
   * @param  {Boolean} inIframe
   * @return {String}            String to access SlaaskApp from inline HTML Javascript (onclick)
   */
  _mainObject(inIframe) {
    return (inIframe ? "parent." : "") + "_" + this._brand;
  }

  destroy() {
    if (!this._destroyed) {
      this._destroyed = true;
      Utils.reset();
      this._trigger('destroy');

      if (this._websocketClient) {
        this._websocketClient.disconnect();
        this._websocketClient = null;
      }

      let viewConstructors = [];
      Views.forEach(view => {
        viewConstructors.push(view.constructor);
      });

      let componentConstructors = [];
      Dom.forEachComponents(component => {
        componentConstructors.push(component.constructor);
      });

      let destroyModule = (module, name) => {
        module.destroy();
        let newModule = new module.constructor();

        newModule.attachSlaask(this);

        // Magic that overrides the module in closure without moving the reference
        Object.assign(module, newModule);

        // The new module constructed is automatically referenced in the list. We change back the refence to the previous one
        AbstractModule.list[name] = module;
      };

      Utils.forEach(AbstractModule.list, (module, name) => {
        if (name != "Dom") destroyModule(module, name);
      });
      destroyModule(Dom, "Dom");

      Utils.forEach(Dom.findAll('parent', '.slaask-style-sheet'), cssTag => {
        Utils.removeElement(cssTag);
      });

      Utils.forEach(viewConstructors, Construct => {
        Views.add(new Construct);
      });

      Utils.forEach(componentConstructors, Construct => {
        Dom.addComponent(new Construct);
      });

      this._guest_token = null;
    } else {
      console.log('Already destroyed');
    }
  }

};

// Make class global so we can force re-init if needed
window.SlaaskApp = SlaaskApp;

// Retro compatibility
window.slaaskApp = SlaaskApp;
